import React, {useState, useRef} from 'react';
import '../../../css/forgotpassword.scss';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css'
import APICall from '../../actions/apicall';
import cancelIcon from '../../../images/cancelIcon.png';
import Submit from '../reusable/Submit';

function ForgotPassword(props) {
    const [emailAddress, setEmailAddress] = useState('');
    const [showEmail, setShowEmail] = useState(true);
    const [submitText, setSubmitText] = useState('Submit');
    const [showError, setShowError] = useState(false);
    const [messageText, setMessageText] = useState('');
    
    const handleEnteredEmail = () => {
        setSubmitText('Submitting...');
        window.dataLayer.push({'event': 'forgot_password_submit'});
        let data = {
            email: emailAddress
        }
        APICall.ForgotPasswordEmail(data, (response) => {
            if (response.status == 200 && response.data.status == 'success') {
                setMessageText(response.data.message);
                setShowEmail(false);
            }
            else {
                setMessageText(response.data.message);
                setShowError(true);
            }
            setSubmitText('Submit');
        });
    }

    const handleCloseButtonClick = () => {
        setShowEmail(true);
        props.CloseForgotPassword();
        window.dataLayer.push({'event': 'forgot_password_exit'});
    }
    

    return(
        <>
        {
            <BottomSheet open={true} onDismiss={() => handleCloseButtonClick()}
                header={
                    <div className="transparent-header">
                        <img className='cancel-icon' height='25px' src={cancelIcon} onClick={() => handleCloseButtonClick()} />
                    </div>
                }
            >
                <div className='forgot-password-container'> 
                {       
                    (showEmail) ? (  
                    <div>  
                        <p className='forgot-text'>Forgot Password</p>
                        <hr></hr>
                        <div className='input-container'>
                            <input 
                                className="email-input" 
                                type="email"
                                id='forgot-password'
                                placeholder='Email address' 
                                value={emailAddress}
                                onKeyPress={(e) => ((e.key == 'Enter') && handleEnteredEmail())}
                                onChange={(e) => setEmailAddress(e.target.value)}
                            />
                            {
                                (showError) && (
                                <p className='forgot-error'>{messageText}</p>)
                            }
                        </div>
                        {
                            (emailAddress.trim().length != 0) ? (
                                <Submit actionText={submitText} callFunction={handleEnteredEmail} disable={submitText != 'Submit' && true} />
                            ) : (
                                <Submit actionText={'Submit'} disable={'button'} />
                            )
                        }
                    </div>) : (
                        <div className='success-container'>
                            <p className='success-text'>{messageText}</p>
                            <button className='done-button' onClick={handleCloseButtonClick}>
                                    <span>Done</span>
                            </button>
                        </div>
                    )
                }
                </div>
            </BottomSheet>
        }
        </> 
    )
}

export default ForgotPassword;


